import React, { useState, useEffect, useRef, Fragment } from "react";
import LayoutHOC from "../LayoutHOC";
import CustomerListTable from "../customer/CustomerListTable";
import taskPodHead from "../customer/TaskPodHead";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import useRequireAuth from "../../utils/useRequireAuth";
import { useParams } from "react-router-dom";

import GentChart from "../GlobalFeature/Chart/GentChart";
import NavBarTabs from "../GlobalFeature/Others/NavBarTabs";
import {
  useDeleteTaskMutation,
  useFetchCustomerTaskPodTableDataQuery,
  useUpdateCustomerTaskPodTableDataMutation,
} from "../../utils/customer/customerTaskTable";
import {
  useFetchPersonInTableQuery,
  useLazyFetchCustomerTableQuery,
  useLazyFetchPersonInTableQuery,
} from "../../utils/customer/customerTable";
import { useCustomerTableMutation } from "../../utils/customer/customerTable";
import useFirstLetters from "../../hooks/LetterShow/useFirstLetters";
import FirstLetters from "../GlobalFeature/Letters/FirstLetters";
import QuickFilter from "../GlobalFeature/Table/HeadTop/QuickFilter";
import { getUserTokeData } from "../../utils/userSlice";
import { useLocation } from "react-router-dom";
import TaskPodRecurrenceCalendar from "../Task/TaskRecurrence/TaskPodRecurrenceCalendar";
import useFormatDate from "../../hooks/DateFormatter/useFormatDate";
import { Tooltip } from "@mui/material";
import styled from "@emotion/styled";
import RecurrenceIcon from "../Icons/RecurrenceIcon";
import ExceptionIcon from "../Icons/ExceptionIcon";
import CalendarIconWithTime from "../Icons/CalendarIconWithTime";
import EditOptionsModal from "../Task/TaskRecurrence/EditOptionsModal";
import { ReactComponent as ExpandCollapsIMG } from "../../assets/images/expandCollapsIMG.svg";
import { ReactComponent as SubTaskWhiteIcon } from "../../assets/images/subTaskWhiteIcon.svg";
import { ReactComponent as HandleToggleSubTaskIcon } from "../../assets/images/handleToggleSubTaskIcon.svg";
import EditOptionsTaskPodModal from "../Task/TaskRecurrence/EditOptionsTaskPodModal";
import { DayPilot } from "@daypilot/daypilot-lite-react";
import ScrollableTabs from "../UniversalComponents/ScrollableTabs";
import { pushAlert } from "../../utils/alertSlice";
import AddTaskPodModal from "./../Task/AddTaskPodModal";
const stringData = (dateString) => {
  if (!dateString || dateString.trim() === "") return "";
  const data = dateString?.split("-");
  return `${data[2]}-${data[1]}-${data[0]}`;
};

const TaskPod = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  const hashValue = location.hash.substring(1);

  const [activeTab, setActiveTab] = useState(hashValue);

  const [quiFilter, setQuiFilter] = useState();
  const [initialFilter, setInitialFilter] = useState([]);

  const [customer, setCustomer] = useState([]);
  const [customerMainData, setCustomerMainData] = useState([]);

  const token = useRequireAuth();

  const storedData = localStorage.getItem("company_data");

  const companyId = storedData ? JSON.parse(storedData) : null;

  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const { name: taskPod } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const showMessage = useSelector((state) => state.tasks.showMessage);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [editData, setEditData] = useState();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [view, setView] = useState("Day");
  const [startDate, setStartDate] = useState(DayPilot.Date.today());

  const [isGridActive, setIsGridActive] = useState(false);
  const [listview, setListView] = useState(true);
  const [calview, setCalView] = useState(false);

  const [subTaskOpen, setSubTaskOpen] = useState([]);

  const [userDataId, setUserDataId] = useState([]);
  const [totalData, setTotalData] = useState(null);

  const taskFormSubmit = useSelector((state) => state.tasks);

  const { data: customerTableALL, refetch: refetchCustomerData } = useFetchCustomerTaskPodTableDataQuery({
    task_pod: taskPod,
    company_id: companyId,
    pagination: `${customerTablePagination}`,
    paginate: true,
    quiFilter: quiFilter?.value,
    token: token,
    assign_id: userDataId?.id,
    filter_tab: activeTab.slice(1),
  });

  useEffect(() => {
    if (!hashValue && customerTableALL?.task_count) {
      const firstKey = Object.keys(customerTableALL.task_count)[0];
      if (firstKey) {
        setActiveTab(`#${firstKey}`);
      }

      console.log("recccc", customerTableALL);
      setTotalData(customerTableALL?.total);
    }
  }, [hashValue, customerTableALL]);

  const formatEndDate = useFormatDate();

  const CircleSpan = styled("span")({
    display: "inline-block",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    textAlign: "center",
    lineHeight: "24px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#fff",
  });

  const getTransformedData = (val) => {
    console.warn(val, 112, "sdfghjgfdsa");
    const transformedData = val.map((obj) => {
      let end_date = obj?.end_date.slice(0, 10);
      let start_date = obj?.start_date.slice(0, 10);

      const formattedStartDate = formatEndDate(start_date);
      const formattedEndDate = formatEndDate(end_date);

      let transformedObj = {};

      Object.keys(obj).forEach((key, index) => {
        if (key === "status") {
          transformedObj[key] = {
            value: JSON.stringify({
              value: obj?.status ? obj?.status : "",
              color_code: obj?.status_colour_code ? obj?.status_colour_code : "",
            }),

            type: null,
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        } else if (key === "id") {
          transformedObj[key] = {
            value: obj?.id ? obj?.id : "",
            type: null,
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        } else if (key === "due_date") {
          transformedObj[key] = {
            value: formattedStartDate.slice(0, 6) + " - " + formattedEndDate.slice(0, 6),
            type: "date",
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        } else if (key === "assigned_to") {
          transformedObj["assigned_to"] = {
            value: JSON.stringify(obj[key]),
            // value: ([{"id":34,"name":"Shashi Raj","email":"shashi.r@globalfpo.com"}]),
            type: "multi_person",
            field_options: null,
            table_name: null,
            field_name: "assigned_to",
            id: index,
          };
        } else if (key === "priority") {
          transformedObj[key] = {
            value: (
              <Tooltip
                title={<span className="capitalize">{obj[key]}</span>}
                placement="right"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "common.white",
                      filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                      color: "#383838",
                      "& .MuiTooltip-arrow": {
                        color: "common.white",
                      },
                    },
                  },
                }}
              >
                <CircleSpan
                  className={`capitalize border border-020f0026  !font-normal`}
                  style={{
                    backgroundColor: obj?.priority_colour_code ? `${obj?.priority_colour_code}1A` : "#8282821A",
                    color: obj?.priority_colour_code ? obj?.priority_colour_code : "#828282",
                  }}
                >
                  {obj[key][0]}
                </CircleSpan>
              </Tooltip>
            ),
            type: "date",
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        } else if (key === "sub_tasks") {
          transformedObj[key] = {
            value: obj[key].map((subtask, subtaskIndex) => {
              const transformedSubtask = {};
              Object.keys(subtask).forEach((subKey) => {
                if (subKey === "assigned_to") {
                  transformedSubtask["assigned_to"] = {
                    value: JSON.stringify(subtask[subKey]),
                    // value: ([[{"id":34,"name":"Shashi Raj","email":"shashi.r@globalfpo.com"}]]),
                    type: "multi_person",
                    field_options: null,
                    table_name: null,
                    field_name: "assigned_to",
                    id: index,
                  };
                } else {
                  transformedSubtask[subKey] = {
                    value: subtask[subKey],
                    type: null,
                    field_options: null,
                    table_name: null,
                    field_name: subKey,
                    id: `${index}-${subtaskIndex}`,
                  };
                }
              });
              return transformedSubtask;
            }),
            type: "children",
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        } else {
          transformedObj[key] = {
            value: obj[key],
            type: null,
            field_options: null,
            table_name: null,
            field_name: key,
            id: index,
          };
        }
      });

      // Object.keys(obj).forEach((key,index) => {
      //   transformedObj[key] = {
      //     "value": obj[key],
      //     "type": null,
      //     "field_options": null,
      //     "table_name": null,
      //     "field_name": key,
      //     "id": index
      //   };
      // });

      return transformedObj;
    });

    return transformedData;
  };

  // const getFilteredData = (data) => {
  //   console.warn(data, "qedfghjyhgfd");
  //   switch (activeTab) {
  //     case "#OverDue":
  //       return data.filter((item) => new Date(item.end_date) < new Date());
  //       break;
  //     case "#Completed":
  //       return data.filter((item) => item?.status === "Completed");
  //       break;
  //     case "#Other":
  //       return data.filter(
  //         (item) => item?.status === "Hold" || item?.status === "Cancelled" || item?.status === "Drop"
  //       );
  //       break;
  //     default:
  //       return data;
  //       break;
  //   }
  // };

  useEffect(() => {
    if (customerTableALL) {
      // setCustomer(customerTableALL?.data);

      const { data, ...restData } = customerTableALL;

      // let filteredData = getFilteredData(data);

      const transformedData = getTransformedData(data);

      // let filteredData = getFilteredData(customerTableALL?.data);

      // const transformedData = getTransformedData(filteredData);

      // const transformedData = getTransformedData(customerTableALL?.data);

      // setCustomer(transformedData);

      // setInitialFilter(restData);
      setCustomer(transformedData);
      setCustomerMainData(data);
      setInitialFilter(restData);

      setLoading(false);
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData, activeTab]);

  useEffect(() => {
    if (taskFormSubmit?.tasks?.data?.data) {
      refetchCustomerData();
    }
  }, [taskFormSubmit?.tasks?.data?.data]);

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => fetchPersonInTable({ token: token?.token, data, companyId: companyId });

  const { data: quickpersonTableData } = useFetchPersonInTableQuery({
    token: token?.token,
    data: "",
  });

  const [updateCustomerTaskPodTableData, { CustomerDropLoad, CustomerDroperror }] =
    useUpdateCustomerTaskPodTableDataMutation();

  const handleNavigate = (customer_id, data) => {
    setIsEditPopupOpen(true);

    const isSubtask = data?.parent_task_id?.value !== null;

    // Get the parent task data
    const parentTaskData = isSubtask
      ? customerMainData?.find((item) => item.id === data?.parent_task_id?.value)
      : customerMainData?.find((item) => item.uuid === data?.uuid?.value);

    if (parentTaskData) {
      const updatedFinalData = {
        ...parentTaskData,
        start: { value: parentTaskData?.start_date },
        end: { value: parentTaskData?.end_date },
      };

      setEditData(updatedFinalData);
    }
  };

  useEffect(() => {
    dispatch(getUserTokeData());
  }, [location]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const openPopup = () => {
    setIsPopupOpen(true);
    dispatch(getUserTokeData());
  };

  const closePopup = () => {
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
    setEditData();
  };

  const [CustomerTableDrop, { data: customerCommnData, refetch: refetchCustomerCommnData }] =
    useCustomerTableMutation();

  const fetchCustomerTable = (data) => {
    const completedata = {
      model_name: "task",
      field_name: data,
    };

    CustomerTableDrop({ token: token?.token, data: completedata });
  };

  const customerTableFieldUpdate = async (field_name, value) => {
    let datevalue;
    if (value?.field_name === "start_date" || value?.field_name === "end_date") {
      datevalue = stringData(field_name.value);
    } else {
      datevalue = value?.field_name === "owner" ? field_name.name : field_name.value;
    }

    const updateData = {
      field_name: value?.field_name,
      value: datevalue,
      id: value?.id,
    };

    try {
      const result = await updateCustomerTaskPodTableData({
        token: token?.token,
        data: updateData,
      }).unwrap();
      refetchCustomerData();
      dispatch(
        pushAlert({
          message: result?.data?.original?.error || result?.message,
          type: result?.data?.original?.error ? "danger" : "success",
        })
      );
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger" }));
    }
  };

  const [taskExpand, setTaskExpand] = useState(false);
  const TaskExpand = () => setTaskExpand(!taskExpand);
  const isOpen = () => {};
  const TaskNavbarQuickFilter = (option) => {
    setQuiFilter(option);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    if (refreshKey) {
      refetchCustomerData();
    }
  }, [refreshKey]);

  const activityClosed = (val) => {
    refetchCustomerData();
  };

  let expandbtn = (
    <div className={`flex justify-end items-center mb-1`}>
      <div className="me-3">
        <NavBarTabs
          tabs={["Days", "Weeks", "Months"]}
          initialTab="Days"
          TabButtonClass="rounded px-3 py-1 cursor-pointer text-xs font-medium"
          activeStyle="bg-254155  text-white"
          inactiveStyle="bg-f1f6f9 text-434852"
          // onTabChange
        />
      </div>

      <button className="bg-white border border-E1E1E1 py-1 px-3" onClick={TaskExpand}>
        <i className="bi bi-arrows-fullscreen"></i>
      </button>
    </div>
  );

  const changeToListView = () => {
    setListView(true);
    setCalView(false);
  };

  const changeToCaltView = () => {
    setListView(false);
    setCalView(true);
  };

  const handleGridClick = () => {
    setIsGridActive(!isGridActive);
    changeToCaltView();
  };

  const handleEditFields = (selection) => {
    const Selectedaccordfield = { ...editData, selection };
    setEditData(Selectedaccordfield);
  };

  const ViewData = () => {
    return (
      <div className={`flex items-center justify-end ${calview ? "pb-1" : ""}`}>
        <div
          className={`border-[1px] flex justify-center items-center rounded-l-[5px] rounded-r-[5px] border-[rgba(29, 68, 105, 0.20)] bg-white me-1`}
          role="group"
        >
          <button
            className="flex items-center h-[28px] px-3 py-[5px] text-sm font-medium text-gray-900 bg-white rounded-l-lg border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white focus:z-10 focus:ring-2 focus:ring-gray-200 focus:text-gray-200"
            onClick={changeToListView}
          >
            <i className="bi bi-list-ul text-848687 hover:text-white"></i>
          </button>

          <button
            className={`flex items-center h-[28px] px-3 py-[5px] text-sm font-medium text-gray-900 bg-white ${calview ? "" : "rounded-r-lg"} border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white focus:z-10 focus:ring-2 focus:ring-gray-200 focus:text-gray-200 border-l border-[rgba(29, 68, 105, 0.20)]`}
            onClick={handleGridClick}
          >
            <i className="bi bi-grid text-848687 hover:text-white"></i>
          </button>

          {calview && (
            <Fragment>
              <button
                onClick={() => setView("Day")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Day" ? "bg-1D4469 text-white" : ""}`}
              >
                Day
              </button>
              <button
                onClick={() => setView("Week")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Week" ? "bg-1D4469 text-white" : ""}`}
              >
                Week
              </button>
              <button
                onClick={() => setView("Month")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Month" ? "bg-1D4469 text-white rounded-r-[5px]" : ""}`}
              >
                Month
              </button>
            </Fragment>
          )}
        </div>
        {calview && (
          <button
            type="button"
            className="bg-1D4469 text-12 text-white rounded-5px h-[30px] w-[84px] border-[rgb(29 68 105 100%))] hover:bg-123251"
            onClick={() => {
              setStartDate(DayPilot.Date.today());
            }}
          >
            Today
          </button>
        )}
      </div>
    );
  };

  const handleToggleSubTasks = (taskid, data, header) => {
    console.log("taskid0910", taskid);
    setSubTaskOpen((prevState) => {
      if (prevState.includes(taskid)) {
        return prevState.filter((item) => item != taskid);
      } else {
        return [...prevState, taskid];
      }
    });
  };

  const handleRecurrence = (taskid, data, header) => {
    setIsEditPopupOpen(true);
    const finalData = customerMainData?.find((item) => item.uuid === data?.uuid?.value);

    if (finalData) {
      const updatedFinalData = {
        ...finalData,
        start: { value: finalData?.start_date },
        end: { value: finalData?.end_date },
      };

      setEditData(updatedFinalData);
    }
    // setEditData(finalData);
  };

  const UserIdBasedData = (data) => {
    setUserDataId(data);
  };

  const [deleteTask] = useDeleteTaskMutation();

  const handleDeleteTask = async (data) => {
    try {
      await deleteTask({ token: token?.token, data }).unwrap();
      refetchCustomerData();
    } catch (error) {}
  };

  return (
    <div className={`px-4 py-0.5`}>
      <div>
        <div>
          <nav className="px-4">
            <div className="container ">
              <div className="flex justify-between ">
                <div className="tablemaindiv customerTaskTable">
                  {isPopupOpen && (
                    <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                      <AddTaskPodModal
                        isOpen={isOpen}
                        closePopup={closePopup}
                        taskid={editData}
                        taskPod={taskPod}
                        completeData={customerMainData}
                        key={refreshKey}
                        refetch={refetchCustomerData}
                        setAlert={setAlert}
                        alert={alert}
                      />
                    </div>
                  )}
                  {editData?.is_recurrence === 0 && (
                    <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                      <AddTaskPodModal
                        isOpen={isOpen}
                        closePopup={closePopup}
                        taskid={editData}
                        completeData={customerMainData}
                        refetch={refetchCustomerData}
                        setAlert={setAlert}
                        alert={alert}
                      />
                    </div>
                  )}

                  {editData?.is_recurrence === 1 && (
                    <EditOptionsTaskPodModal
                      onClose={closePopup}
                      onOpen={editData}
                      onSave={handleEditFields}
                      refetch={refetchCustomerData}
                    />
                  )}
                </div>
              </div>

              <div className="md:hidden">
                <button className="text-white focus:outline-none">
                  {/* <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16m-7 6h7"
                    ></path>
                  </svg> */}
                  <ExpandCollapsIMG />
                </button>
              </div>
            </div>
          </nav>

          <div>
            {listview && (
              <CustomerListTable
                key={refreshKey}
                tableDetail={{
                  tableidclass: "fullscreen-table",
                  tableparentidclass: "tableparent",
                  tableHeading: "All Tasks",
                  // forcefullyfreeze: true,
                  allrowclicknavigate: true,
                  TableLeadFilter: (
                    <Fragment>
                      <ScrollableTabs
                        tabData={customerTableALL?.task_count}
                        tabColor={customerTableALL?.task_status_color}
                        activeTab={activeTab}
                        handleTabClick={handleTabClick}
                      />
                    </Fragment>
                  ),
                  tablenameclass: "font-medium text-16 text-203C50 capitalize",
                  tableSearch: true,
                  tableFilter: true,
                  tablequickfilter: (
                    // <Fragment>
                    //   <div className="flex">
                    //     <QuickFilter
                    //       options={quickpersonTableData}
                    //       placeholder={<span className="text-848687">User Filter</span>}
                    //       onSelect={(option) => UserIdBasedData(option)}
                    //       className={"h-[25vh] overflow-auto"}
                    //     />
                    //   </div>
                    // </Fragment>
                    <Fragment>
                      <div className="flex">
                        <QuickFilter
                          options={[
                            { id: 1, name: "All", value: "" },
                            { id: 2, name: "Due Today", value: "due_today" },
                            { id: 3, name: "Due This Week", value: "due_this_week" },
                            { id: 4, name: "Due Next Week", value: "due_next_week" },
                            { id: 5, name: "Created by me", value: "created_by_user" },
                            { id: 6, name: "Assigned To me", value: "assigned_to_me" },
                          ]}
                          placeholder={
                            <span className="text-848687">{quiFilter?.name ? quiFilter?.name : "Quick Filter"}</span>
                          }
                          onSelect={TaskNavbarQuickFilter}
                        />
                        <span className="mx-1"></span>
                      </div>
                    </Fragment>
                  ),
                  quiFilter: quiFilter,
                  setQuiFilter: setQuiFilter,
                  tableResizer: true,
                  tableZoom: true,
                  tableheader: true,
                  dataactivity: true,
                  headeraddfield: false,
                  addbutton: (
                    <button onClick={openPopup} type="button" className="text-2541558A hover:text-254155">
                      <i className="bi bi-plus-lg"></i>
                    </button>
                  ),
                  actionfield: (data) => (
                    <Fragment>
                      <td className="w-[50px] border-hidden sticky z-50 right-0">
                        <div className="text-left pl-[10px] ">
                          {data?.is_deletable?.value ? (
                            <button
                              className="text-F84545 text-15 text-left delete-button"
                              onClick={() => handleDeleteTask(data)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M3.04017 5L3.9258 15.6912C3.98927 16.4622 4.646 17.0667 5.41993 17.0667H13.5801C14.354 17.0667 15.0108 16.4622 15.0742 15.6912L15.9598 5H3.04017ZM6.99953 15.0667C6.7378 15.0667 6.5176 14.8631 6.501 14.5979L6.001 6.53123C5.9839 6.25537 6.19337 6.01807 6.46877 6.00097C6.7544 5.98093 6.98147 6.19287 6.99903 6.46873L7.49903 14.5354C7.51673 14.8211 7.2907 15.0667 6.99953 15.0667ZM10 14.5667C10 14.843 9.77637 15.0667 9.5 15.0667C9.22363 15.0667 9 14.843 9 14.5667V6.5C9 6.22363 9.22363 6 9.5 6C9.77637 6 10 6.22363 10 6.5V14.5667ZM12.999 6.53127L12.499 14.5979C12.4826 14.8604 12.2638 15.0791 11.9687 15.0657C11.6933 15.0486 11.4839 14.8113 11.501 14.5354L12.001 6.46877C12.0181 6.1929 12.2598 5.9922 12.5312 6.001C12.8066 6.0181 13.0161 6.2554 12.999 6.53127Z"
                                  fill="#F84545"
                                />
                                <path
                                  d="M16 2H13V1.5C13 0.672867 12.3271 0 11.5 0H7.5C6.67287 0 6 0.672867 6 1.5V2H3C2.4477 2 2 2.4477 2 3C2 3.55223 2.4477 4 3 4C7.59887 4 11.4013 4 16 4C16.5523 4 17 3.55223 17 3C17 2.4477 16.5523 2 16 2ZM12 2H7V1.5C7 1.22413 7.22413 1 7.5 1H11.5C11.7759 1 12 1.22413 12 1.5V2Z"
                                  fill="#F84545"
                                />
                              </svg>
                            </button>
                          ) : null}
                        </div>
                      </td>
                    </Fragment>
                  ),
                  addbuttonToday: <Fragment>{ViewData()}</Fragment>,
                }}
                thead={taskPodHead}
                tbody={customer}
                totalData={totalData}
                tablePaginationData={setCustomerTablePagination}
                fetchtableBodyData={fetchCustomerTable}
                customerCommnData={customerCommnData || personTableData}
                fetchPersonInTable={fetchPersonData}
                TableFieldUpdate={customerTableFieldUpdate}
                initialFilter={initialFilter}
                handleNavigate={handleNavigate}
                navigateNameCondition={[
                  "customer_name",
                  "customer_display_name",
                  "subject",
                  "due_date",
                  "assigned_to",
                  "status",
                  "priority",
                  "description",
                ]}
                TextFieldElement={{
                  dropdown: (DataText, tableDetail) => {
                    return <FirstLetters text={DataText} />;
                  },
                }}
                subTaskOpen={subTaskOpen}
                setSubTaskOpen={setSubTaskOpen}
                ExtraFieldComponent={{
                  subject: (item, header) => (
                    <Fragment>
                      {item?.sub_tasks?.value && item?.sub_tasks?.value?.length > 0 && (
                        <Tooltip
                          title="Sub Task"
                          placement="right"
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "common.white",
                                filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                color: "#383838",
                                "& .MuiTooltip-arrow": {
                                  color: "common.white",
                                  filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                  color: "#383838",
                                  "& .MuiTooltip-arrow": {
                                    color: "common.white",
                                    filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          <button
                            data-task-id={item.id.value}
                            // className="bg-[#F1F1F1] rounded p-1 ms-4"
                            className={
                              subTaskOpen.includes(item?.id?.value)
                                ? "bg-[#567A9D] rounded p-1 ms-4"
                                : "bg-[#F1F1F1] rounded p-1 ms-4"
                            }
                            type="button"
                            onClick={() => {
                              // handleChildren(item?.id?.value, item, header);
                              handleToggleSubTasks(item?.id?.value, item, header);
                            }}
                          >
                            {subTaskOpen.includes(item?.id?.value) ? (
                              // <svg
                              //   xmlns="http://www.w3.org/2000/svg"
                              //   width="9"
                              //   height="9"
                              //   viewBox="0 0 10 10"
                              //   fill="blue"
                              // >
                              //   <path
                              //     d="M1.25 4.16667H2.91667C3.60417 4.16667 4.16667 3.60417 4.16667 2.91667V2.5H7.08333C7.3125 2.5 7.5 2.6875 7.5 2.91667V5.83333H5.83333V8.75C5.83333 9.4375 6.39583 10 7.08333 10H8.75C9.4375 10 10 9.4375 10 8.75V5.83333H8.33333V2.91667C8.33333 2.22917 7.77083 1.66667 7.08333 1.66667H4.16667V0H0V2.91667C0 3.60417 0.5625 4.16667 1.25 4.16667ZM9.16667 8.75C9.16667 8.97917 8.97917 9.16667 8.75 9.16667H7.08333C6.85417 9.16667 6.66667 8.97917 6.66667 8.75V6.66667H9.16667V8.75ZM0.833333 0.833333H3.33333V2.91667C3.33333 3.14583 3.14583 3.33333 2.91667 3.33333H1.25C1.02083 3.33333 0.833333 3.14583 0.833333 2.91667V0.833333Z"
                              //     fill="white"
                              //   />
                              // </svg>
                              <SubTaskWhiteIcon />
                            ) : (
                              // <svg
                              //   xmlns="http://www.w3.org/2000/svg"
                              //   width="10"
                              //   height="10"
                              //   viewBox="0 0 10 10"
                              //   fill="none"
                              // >
                              //   <path
                              //     d="M8.75 5.83333H7.08333C6.39583 5.83333 5.83333 6.39583 5.83333 7.08333V7.5H2.91667C2.6875 7.5 2.5 7.3125 2.5 7.08333V4.16667H4.16667V1.25C4.16667 0.5625 3.60417 0 2.91667 0H1.25C0.5625 0 0 0.5625 0 1.25V4.16667H1.66667V7.08333C1.66667 7.77083 2.22917 8.33333 2.91667 8.33333H5.83333V10H10V7.08333C10 6.39583 9.4375 5.83333 8.75 5.83333ZM0.833333 1.25C0.833333 1.02083 1.02083 0.833333 1.25 0.833333H2.91667C3.14583 0.833333 3.33333 1.02083 3.33333 1.25V3.33333H0.833333V1.25ZM9.16667 9.16667H6.66667V7.08333C6.66667 6.85417 6.85417 6.66667 7.08333 6.66667H8.75C8.97917 6.66667 9.16667 6.85417 9.16667 7.08333V9.16667Z"
                              //     fill="#567A9D"
                              //   />
                              // </svg>
                              <HandleToggleSubTaskIcon />
                            )}
                          </button>
                        </Tooltip>
                      )}

                      {/* {expandedTasks[item?.id?.value] && (
                                <div className="pl-4 mt-2">
             
                                  {item?.sub_tasks?.value.map((childTask, index) => (
                                    <div key={childTask.id} className="border-l-2 border-gray-300 pl-2">
                                 
                                      <span>{childTask.subject.value}</span>
                                    </div>
                                  ))}
                                </div>
                              )} */}
                    </Fragment>
                  ),
                  due_date: (item, header) => (
                    <Fragment>
                      {item?.is_recurrence?.value === 1 && item?.is_exception?.value !== 1 ? (
                        <Tooltip
                          title="Recurrence"
                          placement="left"
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "common.white",
                                filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                color: "#383838",
                                "& .MuiTooltip-arrow": {
                                  color: "common.white",
                                  filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                },
                              },
                            },
                          }}
                        >
                          <button
                            className=" ms-4"
                            onClick={() => {
                              handleRecurrence(item?.id?.value, item, header);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M14.0975 14.0974C16.8958 11.2896 16.8958 6.71539 14.0975 3.90753L12.6048 5.40025V0.902874H17.1022L15.3647 2.64039C18.8781 6.14902 18.8781 11.8559 15.3647 15.3694C13.1472 17.5821 10.0609 18.4028 7.20025 17.8172V15.9645C9.58573 16.5837 12.2304 15.9645 14.0975 14.0974Z"
                                fill="#2999BC"
                              />
                              <path
                                d="M2.63567 2.64039C4.85316 0.418098 7.93941 -0.402662 10.8001 0.182909V2.03562C8.41459 1.41645 5.76512 2.04522 3.90281 3.90753C1.09495 6.71539 1.09495 11.2896 3.90281 14.0974L5.39554 12.6047V17.1069H0.893357L2.63087 15.3694C-0.877756 11.8559 -0.877757 6.14902 2.63567 2.64039Z"
                                fill="#2999BC"
                              />
                            </svg>
                          </button>
                        </Tooltip>
                      ) : item?.is_exception?.value === 1 ? (
                        <Tooltip
                          title="Exception"
                          placement="right"
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "common.white",
                                filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                color: "#383838",
                                "& .MuiTooltip-arrow": {
                                  color: "common.white",
                                  filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                },
                              },
                            },
                          }}
                        >
                          <button
                            className=" ms-4"
                            onClick={() => {
                              handleRecurrence(item?.id?.value, item, header);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="22"
                              viewBox="0 0 19 22"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M2.99239 4.69194C2.88604 4.78902 2.78143 4.88905 2.67866 4.99205C-0.892074 8.5579 -0.892072 14.3579 2.67378 17.9286L0.907927 19.6945H5.48354V15.1189L3.96646 16.636C1.11281 13.7823 1.11281 9.13351 3.96646 6.27985C3.98759 6.25873 4.00881 6.23776 4.03013 6.21695L2.99239 4.69194ZM12.1431 18.1392C10.6205 18.8169 8.91213 18.9474 7.31768 18.5335V20.4164C9.28283 20.8187 11.3527 20.568 13.1839 19.6687L12.1431 18.1392ZM15.7657 17.7747L14.7093 16.2224C17.1651 13.3496 17.0378 8.99949 14.3274 6.27985L12.8104 7.79693V3.22619H17.3811L15.6152 4.99205C19.1351 8.50711 19.1853 14.1931 15.7657 17.7747ZM6.75814 4.53783L5.69861 2.98081C7.37784 2.29724 9.21891 2.13477 10.9762 2.49449V4.37741C9.59137 4.01796 8.11897 4.07235 6.75814 4.53783Z"
                                fill="#2999BC"
                              />
                              <path
                                d="M2.41016 1L16.0199 21"
                                stroke="#2999BC"
                                stroke-width="2"
                                stroke-linecap="round"
                              />
                            </svg>
                          </button>
                        </Tooltip>
                      ) : (
                        <button className=" ms-4">
                          <CalendarIconWithTime />
                        </button>
                      )}
                    </Fragment>
                  ),

                  // description: (item, header) => (
                  //   <Fragment>

                  //         <Tooltip
                  //                         title="Description"
                  //                         placement="top"
                  //                         arrow
                  //                         componentsProps={{
                  //                           tooltip: {
                  //                             sx: {
                  //                               bgcolor: 'common.white',
                  //                               filter: 'drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))',
                  //                               color: '#383838',
                  //                               '& .MuiTooltip-arrow': {
                  //                                 color: 'common.white',
                  //                                 filter: 'drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))',
                  //                               },
                  //                             },
                  //                           },
                  //                         }}
                  //         >
                  //                   <button type="button">
                  //                         <i class="bi bi-chat-left-dots text-lg"></i>
                  //                   </button>
                  //         </Tooltip>

                  //   </Fragment>
                  // )
                }}
                activityClosed={activityClosed}
              />
            )}
            {calview && (
              <Fragment>
                {ViewData()}
                <TaskPodRecurrenceCalendar
                  setView={setView}
                  view={view}
                  setStartDate={setStartDate}
                  startDate={startDate}
                />
              </Fragment>
            )}
          </div>
        </div>
        {/* <div className={` ${taskExpand ? "w-[3%]" : "hidden"}`}>
          {taskExpand && expandbtn}
          <div className="no-scrollbar h-[500px] overflow-y-auto">
          </div>
        </div>
        <div className={` ${taskExpand ? "w-[97%]" : "hidden"} ps-4`}>
          <div className="flex justify-between"></div>
          <div className="no-scrollbar h-[500px] overflow-y-auto">
            <div className="px-4 py-5 flex-auto bg-white">
              <p>Gantt Chart</p>
            </div>
          </div>
        </div>

        <div className={`${taskExpand ? "hidden" : "w-[30%]"} mt-2 ps-4`}>
          {!taskExpand && expandbtn}

          <GentChart className="w-100" />
        </div> */}
      </div>
    </div>
  );
};

export default LayoutHOC(TaskPod);
